"use client";
import React from "react";
import { Box, Typography } from "@mui/material";
import Image from "next/image";
import { IconLock } from "@tabler/icons-react";
import AuthLogin from "../auth/AuthLogin";
import { designTokens } from "@/utils/theme/tokens";

const Login = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#fff",
        p: { xs: "40px 24px 24px", md: "40px 28px 28px" },
      }}
    >
      {/* Logo + formulario, centrados */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box sx={{ width: "100%", maxWidth: 392, mb: 5 }}>
          <Image
            src="/images/logos/login_logosoft.png"
            alt="Logosoft"
            width={584}
            height={130}
            priority
            style={{ width: "100%", height: "auto", display: "block" }}
          />
        </Box>
        <AuthLogin />
      </Box>

      {/* Pie */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          mt: 4,
          color: designTokens.color.text.faint,
        }}
      >
        <IconLock size={14} />
        <Typography sx={{ fontSize: 12 }}>
          Acceso exclusivo para personal autorizado · © Logosoft 2026
        </Typography>
      </Box>
    </Box>
  );
};

export default Login;
